import { observer } from "mobx-react";
import type React from "react";
import { useEffect } from "react";
import { Navigate } from "react-router-dom";

import { useProduct } from "hooks/useProduct";
import { useProfile } from "hooks/useProfile";

import { buildUrlWithPathParams } from "_helpers/utils/urlBuilder";
import { PRODUCT_PAGES_ROUTES } from "constants/routes";
import { AccessPageLayout } from "layouts/AccessPageLayout";

import { ROLES } from "@infinitaslearning/module-he-common";
import { NoOwnedProducts, OwnedProductList } from "./components";

export const ProductsOwnedPage: React.FC = observer(() => {
  const { fetchProducts, productsList: ownedProducts } = useProduct();
  const { userDetails, fetchUserDetails } = useProfile();
  const isStudent = userDetails?.role === ROLES.STUDENT;

  useEffect(() => {
    fetchUserDetails();
    fetchProducts();
  }, [fetchProducts, fetchUserDetails]);

  // If user is a student with no products in their account, redirect to no licenses page
  if (isStudent && ownedProducts?.length === 0) {
    return <Navigate to={PRODUCT_PAGES_ROUTES.NO_PRODUCT_LICENSE} replace />;
  }

  // If user only has one product, redirect them directly to its details page
  if (ownedProducts?.length === 1) {
    const productDetailsUrl = buildUrlWithPathParams(PRODUCT_PAGES_ROUTES.PRODUCT_DETAILS, {
      productId: ownedProducts[0].id,
    });

    return <Navigate to={productDetailsUrl} replace />;
  }

  return (
    <AccessPageLayout>
      {ownedProducts && ownedProducts.length > 0 ? <OwnedProductList /> : <NoOwnedProducts />}
    </AccessPageLayout>
  );
});
